import { z } from 'zod';
/* Helsesjekk — contract for GET /api/dashboard/health-check. */
export const okResponse = z.object({ ok: z.literal(true) });
export const healthMonth = z.object({
    month: z.string(),
    payingMembers: z.number(),
    joined: z.number(),
    churned: z.number(),
    churnPct: z.number().nullable(),
    net: z.number(),
    mrr: z.number(),
    refunds: z.number(),
    adSpend: z.number().nullable(),
    cacPerMember: z.number().nullable(),
});
export const benchmark = z.object({
    key: z.string(),
    higherBetter: z.boolean(),
    good: z.number(),
    ok: z.number(),
    unit: z.string(),
    industry: z.string(),
    source: z.string(),
    confidence: z.string(),
});
export const healthResponse = z.object({
    ok: z.literal(true),
    openedMonth: z.string().nullable(),
    openedAt: z.string().nullable(),
    firstPaymentEver: z.string().nullable(),
    preLaunchPayments: z.number(),
    monthsOpen: z.number(),
    today: z.string(),
    currentMonth: z.string(),
    months: z.array(healthMonth),
    cohorts: z.array(z.object({ month: z.string(), size: z.number(), retention: z.array(z.number().nullable()) })),
    stripe: z.object({
        available: z.boolean(),
        subsUsed: z.boolean(),
        payingLast40d: z.number(),
        succeeded90d: z.number(),
        failed90d: z.number(),
        failed30d: z.number(),
        failedPct90d: z.number().nullable(),
        cashNok90d: z.number(),
        refundedNok90d: z.number(),
    }),
    period: z.object({
        from: z.string(),
        to: z.string(),
        membersStart: z.number(),
        membersEnd: z.number(),
        joined: z.number(),
        churned: z.number(),
        churnPct: z.number().nullable(),
        churnPctMonthly: z.number().nullable(),
        revenue: z.number(),
        adSpend: z.number().nullable(),
        days: z.number(),
        avgMembers: z.number(),
        returned: z.number(),
        reconciles: z.boolean(),
    }),
    churnList: z.array(z.object({
        momenceId: z.string(),
        name: z.string(),
        joinedAt: z.string(),
        lastPaidAt: z.string(),
        leftAt: z.string().nullable(),
        monthsStayed: z.number(),
        totalPaid: z.number(),
        everPaid: z.boolean(),
        plan: z.string().nullable(),
    })),
    excluded: z.array(z.object({ momenceId: z.string(), name: z.string() })),
    benchmarks: z.record(z.string(), benchmark),
    joinsPerMonth3m: z.number().nullable(),
    retentionCurve: z.array(z.object({
        month: z.number(),
        eligible: z.number(),
        retained: z.number(),
        pct: z.number().nullable(),
    })),
    measured: z.object({
        everMembers: z.number(),
        activeNow: z.number(),
        activeByPayments: z.number(),
        churnedTotal: z.number(),
        avgLifetimeCompleted: z.number().nullable(),
        avgLifetimeAll: z.number(),
        medianLifetimeCompleted: z.number().nullable(),
        churn3mPct: z.number().nullable(),
        impliedLifetimeMonths: z.number().nullable(),
        arpu: z.number().nullable(),
        ltv: z.number().nullable(),
        revenueTotal: z.number(),
        adSpendTotal: z.number(),
        cacBlended: z.number().nullable(),
    }),
});
//# sourceMappingURL=health.js.map